<template>
  <div class="kt-form kt-form--label-right">
    <p>Retail Sales Flyer and Landing Page Info. Navigate where these fields are displayed on the outputs here <span data-v-ea3d52d4=""><svg data-v-ea3d52d4="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="info-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-info-circle fa-w-16 fa-lg"><path data-v-ea3d52d4="" fill="currentColor" d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z" class=""></path></svg></span>.</p>

    <div class="row">
      <div class="form-group col col-md-4 col-12">
        <BaseLabelWithPopover label="Trip Name:" width="350px">
          <h6>Sales Flyer (PDF)</h6>
          <hr><img src="/img/popover/ConsumerSection_PopOver_TripName.png" alt="" width="350">
          <p>&nbsp;</p>
          <h6>Landing Page (Online): </h6>
          <hr><img src="/img/popover/ConsumerSection_PopOver_TripName_L.png" alt="" width="350">
        </BaseLabelWithPopover>

        <BaseInputForm
          type="text"
          placeholder="Ex. Alphine Europe and Italy"
          v-model="$v[validationGroupName].consumerSection.tripDetails.tripName.$model"
          @blur="$v[validationGroupName].consumerSection.tripDetails.tripName.$touch()"
          :validator="$v[validationGroupName].consumerSection.tripDetails.tripName" />
      </div>
      <div class="form-group col col-md-4 col-12">
        <BaseLabelWithPopover label="Trip Subtitle:" width="350px">
          <h6>Sales Flyer (PDF)</h6>
          <hr><img src="/img/popover/ConsumerSection_PopOver_Subtitle.png" alt="" width="350">
          <p>&nbsp;</p>
          <h6>Landing Page (Online): </h6>
          <hr><img src="/img/popover/ConsumerSection_PopOver_Subtitle_L.png" alt="" width="350">
        </BaseLabelWithPopover>

        <BaseInputForm
          type="text"
          placeholder="Ex. with Oberammergau, The Passion Play"
          v-model="$v[validationGroupName].consumerSection.tripDetails.tripSubtitle.$model"
          @blur="$v[validationGroupName].consumerSection.tripDetails.tripSubtitle.$touch()"
          :validator="$v[validationGroupName].consumerSection.tripDetails.tripSubtitle" />
      </div>
      <div class="form-group col col-md-4 col-12">
        <BaseLabelWithPopover label="Company Name:" width="350px" :hideIcon="true"></BaseLabelWithPopover>

        <BaseInputForm
          type="text"
          placeholder="Ex. Helloworld Travel Top Ryde City"
          v-model="$v[validationGroupName].consumerSection.tripDetails.companyName.$model"
          @blur="$v[validationGroupName].consumerSection.tripDetails.companyName.$touch()"
          :validator="$v[validationGroupName].consumerSection.tripDetails.companyName" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col col-md-4 col-12 validated">
        <div>
          <div class="mb-2">
            <span v-if="!isEditingMultiSharePriceLabel"><strong>{{ $v[validationGroupName].consumerSection.tripDetails.twinsharePriceName.$model }}</strong></span>

            <span v-if="!isEditingMultiSharePriceLabel" class="ml-1 mr-2">
              <font-awesome-icon :icon="['fas', 'info-circle']" size="sm" />
            </span>

            <BaseInputForm v-if="isEditingMultiSharePriceLabel"
              type="text"
              placeholder="Twin Share Price Label"
              v-model="$v[validationGroupName].consumerSection.tripDetails.twinsharePriceName.$model"
              class="d-inline-flex"
            />

            <button v-if="!isEditingMultiSharePriceLabel && canEditPricesNames"
              data-toggle="tooltip" title="Edit Twin Share Price Label"
              type="button"
              class="TabItineraryItem--edit text-danger"
              style="background-color: transparent;border-radius: 50%;border: 1px solid #ae0000;"
              @click.prevent="isEditingMultiSharePriceLabel = !isEditingMultiSharePriceLabel;"
            >
              <font-awesome-icon :icon="['fas', 'pen']" size="sm" />
            </button>

            <div class="ml-2 d-inline-flex" style="gap: .25rem;">
              <!-- <button v-if="isEditingMultiSharePriceLabel"
                data-toggle="tooltip" title="Edit Twin Share Price Label"
                type="button"
                class="TabItineraryItem--edit text-danger"
                style="background-color: transparent;border-radius: 50%;border: 1px solid #ae0000;width: 1.8rem;"
                @click.prevent="isEditingMultiSharePriceLabel = !isEditingMultiSharePriceLabel;"
              >
                <font-awesome-icon :icon="['fas', 'times']" size="sm" />
              </button> -->

              <button v-if="isEditingMultiSharePriceLabel"
                data-toggle="tooltip" title="Edit Twin Share Price Label"
                type="button"
                class="TabItineraryItem--edit text-danger"
                style="background-color: transparent;border-radius: 50%;border: 1px solid #ae0000;width: 1.8rem;"
                @click.prevent="isEditingMultiSharePriceLabel = !isEditingMultiSharePriceLabel;"
              >
                <font-awesome-icon :icon="['fas', 'check']" size="sm" />
              </button>
            </div>
          </div>

          <BaseInputForm
            type="text"
            placeholder="Ex. $4090 per person"
            v-model="$v[validationGroupName].consumerSection.tripDetails.twinsharePrice.$model"
            @blur="$v[validationGroupName].consumerSection.tripDetails.twinsharePrice.$touch()"
            :validator="$v[validationGroupName].consumerSection.tripDetails.twinsharePrice"
          />
        </div>
      </div>
      <div class="form-group col col-md-4 validated">
        <div>
          <div class="mb-2">
            <span v-if="!isEditingSingleSharePriceLabel"><strong>{{ $v[validationGroupName].consumerSection.tripDetails.singleSuppPriceName.$model }}</strong></span>

            <BaseInputForm v-if="isEditingSingleSharePriceLabel"
              type="text"
              placeholder="Single Share Price Label"
              v-model="$v[validationGroupName].consumerSection.tripDetails.singleSuppPriceName.$model"
              class="d-inline-flex"
            />

            <span v-if="!isEditingSingleSharePriceLabel" class="ml-1 mr-2">
              <font-awesome-icon :icon="['fas', 'info-circle']" size="sm" />
            </span>

            <button v-if="!isEditingSingleSharePriceLabel && canEditPricesNames"
              data-toggle="tooltip" title="Edit Single Share Price Label"
              type="button"
              class="TabItineraryItem--edit text-danger"
              style="background-color: transparent;border-radius: 50%;border: 1px solid #ae0000;"
              @click.prevent="isEditingSingleSharePriceLabel = !isEditingSingleSharePriceLabel;"
            >
              <font-awesome-icon :icon="['fas', 'pen']" size="sm" />
            </button>

            <div class="ml-2 d-inline-flex" style="gap: .25rem;">
              <!-- <button v-if="isEditingSingleSharePriceLabel"
                data-toggle="tooltip" title="Edit Single Share Price Label"
                type="button"
                class="TabItineraryItem--edit text-danger"
                style="background-color: transparent;border-radius: 50%;border: 1px solid #ae0000;width: 1.8rem;"
                @click.prevent="isEditingSingleSharePriceLabel = !isEditingSingleSharePriceLabel;"
              >
                <font-awesome-icon :icon="['fas', 'times']" size="sm" />
              </button> -->

              <button v-if="isEditingSingleSharePriceLabel"
                data-toggle="tooltip" title="Edit Single Share Price Label"
                type="button"
                class="TabItineraryItem--edit text-danger"
                style="background-color: transparent;border-radius: 50%;border: 1px solid #ae0000;width: 1.8rem;"
                @click.prevent="isEditingSingleSharePriceLabel = !isEditingSingleSharePriceLabel;"
              >
                <font-awesome-icon :icon="['fas', 'check']" size="sm" />
              </button>
            </div>
          </div>

          <BaseInputForm
              type="text"
              placeholder="Ex. $500 per person"
              v-model="$v[validationGroupName].consumerSection.tripDetails.singleSuppPrice.$model"
              @blur="$v[validationGroupName].consumerSection.tripDetails.singleSuppPrice.$touch()"
              :validator="$v[validationGroupName].consumerSection.tripDetails.singleSuppPrice" />
          </div>
        </div>
    </div>

    <div class="row">
      <div class="form-group col col-md-12">
        <BaseLabelWithPopover label="Landing Page Introduction:" width="350px">
          <h6>Sales Flyer (PDF): N/A</h6>
          <!--<hr><img src="/img/popover/ConsumerSection_PopOver_ShortDescription.png" alt="" width="350">
          <table style="width: 100%;">
          <tbody>
          <tr>
          <td style="text-align: center;">N/A</td>
          <td style="text-align: center;"><strong>195</strong>  [c]<br></td>
          <td style="text-align: center;">N/A</td>
          </tr>
          </tbody>
          </table>-->
          <p>&nbsp;</p>
          <h6>Landing Page (Online): </h6>
          <hr><img src="/img/popover/ConsumerSection_PopOver_ShortDescrition_L.png" alt="" width="350">
        </BaseLabelWithPopover>

        <Editor
          :showDebugger="false"
          :height="100"
          placeholder=""
          :toolbar="['heading', '|', 'bold', 'italic', 'undo', 'redo']"
          :showWordCount="true"
          v-model="$v[validationGroupName].consumerSection.tripDetails.shortDescription.$model"
          @blur="$v[validationGroupName].consumerSection.tripDetails.shortDescription.$touch()"
          :validator="$v[validationGroupName].consumerSection.tripDetails.shortDescription" />
      </div>
    </div>

    <div class="row">
      <div class="form-group col col-md-12">
        <BaseLabelWithPopover label="Terms & Conditions:" width="350px">
          <h6>Sales Flyer (PDF)</h6>
          <hr><img src="/img/popover/ConsumerSection_PopOver_TermsandCondition.png" alt="" width="350">
          <table style="width: 100%;">
          <tbody>
          <tr>
          <td style="text-align: center;"><strong>3638</strong>  [c]<br></td>
          <td style="text-align: center;"><strong>2412</strong>  [c]<br></td>
          <td style="text-align: center;"><strong>4427</strong>  [c]<br></td>
          </tr>
          </tbody>
          </table>
          <p>&nbsp;</p>
          <h6>Landing Page (Online): </h6>
          <hr><img src="/img/popover/ConsumerSection_PopOver_TermsandCondition_L.png" alt="" width="350">
        </BaseLabelWithPopover>

        <Editor
          :showDebugger="false"
          :height="250"
          placeholder=""
          :showWordCount="true"
          v-model="$v[validationGroupName].consumerSection.tripDetails.termsAndConditions.$model"
          @blur="$v[validationGroupName].consumerSection.tripDetails.termsAndConditions.$touch()"
          :validator="$v[validationGroupName].consumerSection.tripDetails.termsAndConditions" />
      </div>
    </div>

  </div>
</template>

<script>
import Editor from '@/components/_shared/Editor.vue'
import { mapGetters } from 'vuex/dist/vuex.common.js';

export default {
  name: 'TabTripDetails',
  inject: ['$v'],
  components: { Editor },
  props: {
    validationGroupName: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      shortDescriptionEditorConfig: {
        placeholder: '',
        toolbar: { items: ['heading', '|', 'bold', 'italic', 'undo', 'redo'] }
      },
      termsAndConditionsEditorConfig: {
        placeholder: '',
        toolbar: { items: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'insertTable', 'undo', 'redo'] }
      },
      isEditingMultiSharePriceLabel: false,
      isEditingSingleSharePriceLabel: false,
    }
  },
  computed: {
    ...mapGetters({
      allowedBrandsIds: 'opportunity/getAllowedBrandsIds',
      opportunity: 'opportunity/opportunity'
    }),
    canEditPricesNames() {
      return this.allowedBrandsIds.includes(this.opportunity.properties_opportunity.id_brand)
    }
  }
}
</script>

<style lang="scss" scopep>
</style>
